import React, { useState } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import * as microsoftTeams from "@microsoft/teams-js";

import Reports from "./pages/reports";
import Dashboard from "./pages/dashboard";
import Projects from "./pages/projects";
import Tasks from "./pages/tasks";
import Settings from "./pages/settings";
import ReportDetail from "./pages/reportDetail";
import ReportForm from "./pages/reportForm";
import ProjectForm from "./pages/projectForm";
import Tools from "./pages/tools";
import ConsentPopup from "./components/auth/consentPopup";
import ClosePopup from "./components/auth/closePopup";
import EditProject from "./components/modals/editProject";
import ConfirmResolveProject from "./components/modals/confirmResolveProject";
import Navigation from "./components/navigation";
import AssignOwner from "./components/modals/assignOwner";
import TaskForm from "./pages/taskForm";
import ConfirmCompleteTask from "./components/modals/confirmCompleteTask";
import CreateInternalComment from "./components/modals/createInternalComment";
import ConfirmDeleteReport from "./components/modals/confirmDeleteReport";
import GenerateReport from "./components/modals/generateReport";

import { useApp } from "./contexts/appContext";

const App = () => {
  const [alreadyNavigated, setAlreadyNavigated] = useState(false);
  const { state: appState } = useApp();
  const history = useHistory();

  microsoftTeams.app.notifyAppLoaded();

  if (window.location.href.indexOf("/modal/") > -1) {
    return (
      <Switch>
        <Route exact path="/modal/project/internalcomment/:id" component={CreateInternalComment} />
        <Route exact path="/modal/project/edit-popup/:id" component={EditProject} />
        <Route exact path="/modal/project/confirmresolve" component={ConfirmResolveProject} />
        <Route exact path="/modal/selectowner" component={AssignOwner} />
        <Route exact path="/modal/project/confirmtask" component={ConfirmCompleteTask} />
        <Route exact path="/modal/report/confirmdelete" component={ConfirmDeleteReport} />
        <Route exact path="/modal/report/generate/:language" component={GenerateReport} />
      </Switch>
    );
  }

  microsoftTeams.app.getContext().then((c: microsoftTeams.app.Context) => {
    if (c.page.subPageId && !alreadyNavigated) {
      setAlreadyNavigated(true);
      history.replace(c.page.subPageId);
    }
  })

  return (
    <>
      <Navigation />
      <div style={{ backgroundColor: appState.backgroundColor }}>
        <Switch>
          <Route exact path="/" component={Reports} />
          <Route exact path="/home" component={Reports} />
          <Route exact path="/report/new" component={ReportForm} />
          <Route exact path="/report/new/:id">
            <ReportForm copy={true} />
          </Route>
          <Route exact path="/report/edit/:id" component={ReportForm} />
          <Route exact path="/report/detail/:id" component={ReportDetail} />
          <Route exact path="/projects" component={Projects} />
          <Route exact path="/project/detail/:id" component={ProjectForm} />
          <Route exact path="/tasks" component={Tasks} />
          <Route exact path="/task/new" component={TaskForm} />
          <Route exact path="/task/detail" component={TaskForm} />
          <Route exact path="/task/detail/:id" component={TaskForm} />
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/settings" component={Settings} />
          <Route exact path="/auth-start" component={ConsentPopup} />
          <Route exact path="/auth-end" component={ClosePopup} />
          <Route exact path="/tools" component={Tools} />
        </Switch>
      </div>
    </>
  );
};

export default App;
